import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classnames from "classnames";

import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { tsParenthesizedType } from "@babel/types";
import { Modal } from "components/modal/Modal";
import { Utils } from "utils/Utils";
import { CreditCard as CreditCardEntity } from "core/types/CreditCard";
import { CreditCard } from "utils/CreditCard";
import { CreditCardInput } from "components/general/CreditCardInput";
import { Termos } from "components/general/Termos";
import { UiActions } from "state/actions/UiActions";

import { Amex } from "components/creditcard/Amex";
import { Diners } from "components/creditcard/Diners";
import { Elo } from "components/creditcard/Elo";
import { Aura } from "components/creditcard/Aura";
import { Hipercard } from "components/creditcard/Hipercard";
import { Mastercard } from "components/creditcard/Mastercard";
import { Visa } from "components/creditcard/Visa";
import { Discover } from "components/creditcard/Discover";
import { Jcb } from "components/creditcard/Jcb";
import { SubscriberRenewalRequest } from "../../core/types/SubscriberRenewalRequest";
import { PaymentMethod } from "../../core/types/PaymentMethod";
import { GlamboxRecaptcha } from "core/glambox/GlamboxRecaptcha";

class AssinaturaRenovar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      pending: false,
      submitted: false,
      loadError: false,
      loadErrorMessage: "",
      currentStep: 0,
      subscriptionTypeId: null,

      cardModal: false,

      termsAccepted: false,
      termsModal: false,

      couponName: "",
      couponShow: false,
      couponError: "",
      couponIsValid: false,

      captcha: null,
      captchaCreated: false,

      reativacaoRetencao: null,

      useActiveCard: true,
      hasDefaultCard: false,
      creditCard: {
        cvv: "",
        name: "",
        number: "",
        flag: {
          id: ""
        },
        expiration: {
          full: "",
          month: "",
          year: ""
        }
      }
    };
    if (!GlamboxRecaptcha.INITIALIZED) {
      GlamboxRecaptcha.init(
        process.env.REACT_APP_RECAPTCHA_SITE_KEY,
        [
          this._recaptchaLoad
        ],
        process.env.REACT_APP_RECAPTCHA_SIZE,
        "glambox-minha-recaptcha"
      );
    } else {
      GlamboxRecaptcha.addListener(this._recaptchaLoad);
    }

  }

  _recaptchaRenew = () => {
    this.props.recaptchaRequest(true);
    GlamboxRecaptcha.execute();
  };

  _recaptchaLoad = (recaptcha) => {
    if (process.env.NODE_ENV === "development") {
      console.log(recaptcha);
    }
  };

  creditCardModalSave = () => {
    this.setState({
      useActiveCard: false
    });
    this.toggleCardModal();
  };

  toggleCardModal = () => {
    this.setState({
      cardModal: !this.state.cardModal
    });
  };

  updateCardItem = (field) => {
    return (evt) => {
      let value = evt.currentTarget.value,
        { creditCard } = this.state;

      switch (field) {
        case "number":
          creditCard.number = value;
          break;
        case "name":
          creditCard.name = value;
          break;
        case "expMonth":
          creditCard.expiration.month = value;
          break;
        case "expYear":
          creditCard.expiration.year = value;
          break;
        case "cvv":
          creditCard.cvv = value;
          break;
      }

      creditCard.expiration.full =
        creditCard.expiration.month + '/' + creditCard.expiration.year;

      this.setState({
        creditCard
      });
    };
  }

  submitReactivateData = () => {

    const { state } = this;

    if (!state.termsAccepted) {
      this.props.publishError("É necessário concordar com nossos termos!");
      return null;
    }

    let data = this.buildRequestData();

    for (let item of data.listPaymentMethod) {
      if (typeof item.creditCard !== "undefined") {
        delete item.creditCard.dateCreated;
        delete item.creditCard.dateUpdated;
      }
    }

    this.props.loaderShow();

    let subscription = state.data.subscriptions[data.subscriptionTypeId];

    let dataLayerEvent = {
      nome_etapa: "finalizacao_" + state.reativacaoRetencao,
      event: state.reativacaoRetencao,
      transactionId: state.reativacaoRetencao + data.subscriberId,
      transactionAffiliation: "Glambox",
      transactionTotal: subscription.info.price - subscription.cost.discountPrice,
      transactionShipping: subscription.cost.shippingPrice,
      transactionDiscount: subscription.cost.discountPrice,
      transactionCoupon: state.couponName,
      transactionTax: 0,
      transactionProducts: [{
        sku: state.reativacaoRetencao + subscription.info.subscriptionTypeId,
        name: state.reativacaoRetencao + subscription.info.subscriptionTypeId,
        category: state.reativacaoRetencao,
        price: subscription.info.price,
        quantity: 1
      }]
    };

    ExecuteRequest(
      GlamboxEndpoints.Subscriber.renewal,
      data,
      "POST",
      {
        Authorization: this.props.token.Authorization
      },
      null,
      (response) => {
        const {
          result,
          statusCode
        } = response;

        this.props.loaderHide();

        if (statusCode === 200) {
          this.props.publishSuccess("Assinatura renovada com sucesso!");

          let hostname = window.location.hostname;
          if (!/(b4a\.net\.br|localhost)/g.test(hostname)) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(dataLayerEvent);
          }
        } else {
          this.props.publishError("Não foi possível renovar sua assinatura!");
          this._recaptchaRenew();
          //window.grecaptcha.execute();
        }

        this.forceUpdate();
        this.props.callback();
        this.props.onCloseModal();
        
      })
    // (result, error) => {
    //   this.props.loaderHide();

    //   if (!error && result.resultType === "SUCCESS") {
    //     this.props.publishSuccess("Assinatura renovada com sucesso!");
    //     window.dataLayer = window.dataLayer || [];
    //     window.dataLayer.push(dataLayerEvent);
    //   } else {
    //     this.props.publishError("Não foi possível renovar sua assinatura!");
    //   }
    // }



    //this._enableInfluencer();

  };

  _enableInfluencer = () => {
    ExecuteRequest(
      GlamboxEndpoints.Partner.enable,
      null,
      "POST",
      {
        Authorization: this.props.token.Authorization
      },
      null,
      (response) => {
        this.props.loaderHide();

        let {
          result,
          statusCode
        } = response;

        if (statusCode === 200) {

          // TODO: IDENTIFY
          this.props.identifyTokenAndPersonId(
            this.props.token.Authorization,
            this.props.token.personId
          );
        }
      }
    );
  };

  buildRequestData = () => {
    const { props, state } = this;

    let flag = CreditCard.getCardFlag(state.creditCard.number);

    let creditCard = new CreditCardEntity(),
      checkoutRequest = new SubscriberRenewalRequest(),
      paymentMethod = new PaymentMethod();

    creditCard.nameOnCard = state.creditCard.name || "";
    creditCard.number = parseInt(state.creditCard.number) || 0;
    creditCard.cvv = state.creditCard.cvv || 0;
    creditCard.creditCardFlagId = (flag !== false) ? flag.id : "";
    creditCard.expMonth = state.creditCard.expiration.month || 0;
    creditCard.expYear = state.creditCard.expiration.year || 0;

    checkoutRequest.couponName = state.couponName;
    checkoutRequest.personId = props.person.person.id;
    checkoutRequest.subscriberId = props.subscriberId;
    checkoutRequest.subscriptionTypeId = state.subscriptionTypeId;
    checkoutRequest.useActiveCard = state.useActiveCard;
    checkoutRequest.captcha = props.recaptcha;

    if (state.useActiveCard === false) {
      checkoutRequest.listPaymentMethod.push(paymentMethod);
      paymentMethod.creditCard = creditCard;
    }

    return checkoutRequest.toObject(true);
  };

  setCaptcha = (captcha) => {
    this.setState({
      captcha: captcha,
      captchaCreated: true
    });
  };

  toggleTermsModal = () => {
    this.setState({
      termsModal: !this.state.termsModal
    });
  };

  toggleTermsAccepted = () => {
    this.setState({
      termsAccepted: !this.state.termsAccepted
    });
  };

  toggleCouponField = () => {
    this.setState({
      couponShow: !this.state.couponShow
    });
  };

  updateCouponField = (evt) => {
    let value = evt.currentTarget.value || "";

    this.setState({
      couponName: value
    });
  };

  sendCouponField = () => {
    if (this.state.couponName.trim() !== "") {
      this.fetchReactivateInfo(this.state.couponName);
    } else {
      this.props.publishError("Por favor, preencha o cupom.");
    }
  };

  resetCouponField = () => {
    this.setState({
      couponName: ""
    });
    this.fetchReactivateInfo("");
  };

  cancelRenewal = () => {
    this.props.onCloseModal();

    if (
      this.props.onCancelRenewal
      && typeof this.props.onCancelRenewal === "function"
    ) {
      GlamboxRecaptcha.reset();
      this.props.onCancelRenewal();
    }
  };

  fetchReactivateInfo = (couponName = null) => {
    this.setState({
      pending: true
    });

    const { token } = this.props;

    ExecuteRequest(
      GlamboxEndpoints.Subscriber.reactivateInfo,
      {
        subscriberId: this.props.subscriberId,
        couponName: couponName || null
      },
      "POST",
      {
        Authorization: token.Authorization,
      },
      null,
      this.reactivateInfoCallback
    );
  };

  reactivateInfoCallback = (response) => {
    let {
      result,
      statusCode
    } = response;

    if (statusCode === 200) {
      let { creditCard, subscriptionTypeId, couponIsValid } = this.state;
      couponIsValid = true;

      let reativacaoRetencao = (result.isRetention === true)
        ? "retencao"
        : "reativacao";

      if (result.creditCard !== null) {
        let newCreditCard = {
          number: result.creditCard ? result.creditCard.number : "",
          maskedNumber: result.creditCard ? result.creditCard.number : "",
          expiration: {
            full: result.creditCard ? result.creditCard.expMonth + "/" + result.creditCard.expYear : "",
            month: result.creditCard ? result.creditCard.expMonth : "",
            year: result.creditCard ? result.creditCard.expYear : ""
          }
        };

        creditCard = Object.assign({}, creditCard, newCreditCard);
      }

      let keys = Object.keys(result.subscriptions);
      for (let key of keys) {
        let curr = result.subscriptions[key];

        if (subscriptionTypeId === curr.info.subscriptionTypeId) {
          if (curr.coupon === null) {
            couponIsValid = false;
          }
        }
      }

      this._recaptchaRenew();
      // if (!this.state.captcha) {
      //   window.grecaptcha.render("captchaSubmit" ,{
      //       'sitekey': '6LexXVUUAAAAADrszPrFY8cb65jUvqjL05IV0D4C',
      //       'size': 'invisible',
      //       'callback': this.setCaptcha
      //   });
      //   window.grecaptcha.execute();
      // }

      this.setState({
        pending: false,
        data: result,
        hasDefaultCard: (result.creditCard !== null && result.creditCard.number !== undefined),
        creditCard: creditCard,
        couponIsValid: couponIsValid,
        reativacaoRetencao
      });
    } else {
      this.setState({
        pending: false,
        loadError: true,
        loadErrorMessage: (result && result.message)
          ? result.message
          : "Erro desconhecido."
      });
    }
  };

  getSubscriptionType = (subscriptionTypeId) => {
    let { subscriptions } = this.state.data;

    let keys = Object.keys(subscriptions);

    for (let key of keys) {
      if (subscriptions[key].info.subscriptionTypeId === subscriptionTypeId) {
        return subscriptions[key];
      }
    }

    return null;
  };

  setSubscriptionTypeId = (subscriptionTypeId) => {
    return () => {
      this.setState({
        subscriptionTypeId: subscriptionTypeId,
        currentStep: this.state.currentStep + 1
      }
      );
    };
  };

  renderCardFlag = () => {
    switch (parseInt(this.state.creditCard.flag.id)) {
      case 1:
        return <Visa size={63} />;
      case 2:
        return <Mastercard size={63} />;
      case 3:
        return <Amex size={63} />;
      case 4:
        return <Diners size={63} />;
      case 5:
        return <Hipercard size={63} />;
      case 6:
        return <Elo size={63} />;
      case 7:
        return <Discover size={63} />;
      case 8:
        return <Aura size={63} />;
      case 9:
        return <Jcb size={63} />;
      default:
        return null;
    }
  };

  renderCreditCardForm = () => {
    return (
      <form>
        Numero<br />
        <input type={"text"} onChange={this.updateCardItem("number")} /><br />
        Nome<br />
        <input type={"text"} onChange={this.updateCardItem("name")} /><br />
        Mes<br />
        <input type={"text"} onChange={this.updateCardItem("expMonth")} /><br />
        Ano<br />
        <input type={"text"} onChange={this.updateCardItem("expYear")} /><br />
        CVV<br />
        <input type={"text"} onChange={this.updateCardItem("cvv")} /><br />
      </form>
    );
  };

  renderCreditCard = () => {
    const { data } = this.state;

    if (data.creditCard === null) {
      return (
        <div>

          <div className={"rn-md-card-infos"}>
            <h5>
              Cartão de Crédito
              {(() => {
                if (this.state.creditCard.maskedNumber) {
                  return (
                    <small>Clique no cartão para alterar.</small>
                  );
                } else {
                  return (
                    <small>Clique no cartão para adicionar.</small>
                  );
                }
              })()}
            </h5>

            {(() => {
              if (this.state.creditCard.maskedNumber) {
                return (
                  <div className={"level-2 credit-card"} onClick={this.toggleCardModal}>
                    {this.renderCardFlag()}
                    <div>
                      <span>{this.state.creditCard.maskedNumber}</span>
                      <small>Expira em: {this.state.creditCard.expiration.full}</small>
                    </div>
                  </div>
                );
              } else {
                return (
                  <div className={"level-2 credit-card"} onClick={this.toggleCardModal}>
                    <div>
                      <span>---- ---- ---- ----</span>
                      <small>Expira em: --/--</small>
                    </div>
                  </div>
                );
              }
            })()}
            {/*<button className={ "gbBt small flat default" }>Alterar</button>*/}

          </div>

          {/*<a onClick={this.toggleCardModal}>
            Modal
          </a>*/}

          <Modal
            visible={this.state.cardModal}
            onCloseModal={this.toggleCardModal}>

            <CreditCardInput onSave={this.updateCardData} />
            <p className={"text-center pt-2"}>
              <button className={"btn btn-sm btn-light-lime"}
                onClick={this.toggleCardModal}>
                Cancelar
              </button>
            </p>
          </Modal>
        </div>
      );
    } else {
      return (
        <div>

          <div className={"rn-md-card-infos"}>
            <h5>
              Cartão de Crédito
              <small>Clique no cartão para alterar.</small>
            </h5>

            <div className={"level-2 credit-card"} onClick={this.toggleCardModal}>
              {this.renderCardFlag()}
              <div>
                <span>{this.state.creditCard.maskedNumber}</span>
                <small>Expira em: {this.state.creditCard.expiration.full}</small>
              </div>
            </div>
            {/*<button className={ "gbBt small flat default" }>Alterar</button>*/}

          </div>

          {/*<a onClick={this.toggleCardModal}>
            Modal
          </a>*/}

          <Modal
            visible={this.state.cardModal}
            onCloseModal={this.toggleCardModal}>

            <CreditCardInput onSave={this.updateCardData} />
            <p className={"text-center pt-2"}>
              <button className={"btn btn-sm btn-light-lime"}
                onClick={this.toggleCardModal}>
                Cancelar
              </button>
            </p>
          </Modal>


        </div>
      );
    }
  };

  updateCardData = (cardData) => {
    this.setState({
      useActiveCard: false,
      creditCard: {
        cvv: cardData.cvv,
        name: cardData.nameOnCard,
        number: cardData.number,
        maskedNumber: cardData.maskedNumber,
        flag: {
          id: cardData.flagId
        },
        expiration: {
          full: cardData.expMonth + "/" + cardData.expYear,
          month: cardData.expMonth,
          year: cardData.expYear
        }
      }
    }, () => {
      this.toggleCardModal();
    });
  };

  renderPlanList = () => {
    const { data } = this.state;

    let keys = Object.keys(data.subscriptions);
    let parsedData = keys.map((item) => {
      return data.subscriptions[item];
    });

    parsedData.sort((a, b) => {
      return b.info.price - a.info.price
    });

    return parsedData.map((item, key) => {
      const { info, coupon, cost } = item;
      let installment = info.price / info.installments;

      if (data.canHaveMonthly === false && info.subscriptionTypeId === 1) {
        return null;
      }

      return (
        <div key={key} className={"rn-item-desk"}>
          <strong>{info.name}</strong>
          <p><span>{info.installments}x</span> {Utils.toCurrency(installment)}</p>
          <button key={key}
            onClick={this.setSubscriptionTypeId(info.subscriptionTypeId)}
            className={"gbBt small flat default"}>
            RENOVAR
          </button>
        </div>
      );
    });
  };

  componentDidMount() {
    this.fetchReactivateInfo();
    //this.renderMensalPlan();
    if (this.props.specialCouponGp && this.props.specialCouponGp !== "") {
      this.setState({
        subscriptionTypeId: 1,
        couponName: this.props.specialCouponGp
      }, () => this.sendCouponField())
    }

  }

  render() {
    const { props, state } = this;

    let currentView = null;

    if (state.pending === true) {
      currentView = (
        <div className={"rn-md-content m-auto"}>
          <div className={"w-space"}>
            <p className={"lead text-muted text-center"}>Carregando...</p>
          </div>
        </div>
      );
    } else if (state.loadError === true) {
      currentView = (
        <div className={"rn-md-content m-auto"}>
          <h4>Não foi possível carregar os dados de planos</h4>
          <div className={"w-space"}>
            <p>
              Por favor, feche esta janela e tente novamente.
            </p>
            <p className={"text-center"}>
              <button className={"btn btn-blue"} onClick={this.cancelRenewal}>
                Cancelar
              </button>
            </p>
          </div>
        </div>
      );
    } else if (state.data && state.subscriptionTypeId === null) {

      currentView = (
        <div className={"rn-md-content m-auto"}>
          <h4>Seleciona aí o plano!</h4>
          <div className={"w-space"}>
            <div className={"rn-plans"}>
              {this.renderPlanList()}
            </div>
          </div>
        </div>
      );
    } else if (state.data && state.submitted === false) {
      let plan = this.getSubscriptionType(this.state.subscriptionTypeId);

      let frete = (plan.cost.shippingPrice === 0)
        ? "Grátis"
        : Utils.toCurrency(plan.cost.shippingPrice);

      let fullPrice = Utils.toCurrency(plan.cost.totalPrice);

      let installment = Utils.toCurrency(plan.cost.installmentPrice);

      let displayPrice = (this.state.subscriptionTypeId === 1)
        ? installment + "/mensal"
        : plan.info.installments + "x " + installment;

      let couponClass = ["coupon"];
      if (state.couponShow === true) couponClass.push("show");

      let desconto = (plan.cost.discountPrice === 0)
        ? null
        : Utils.toCurrency(plan.cost.discountPrice);

      currentView = (
        <div className={"rn-details"}>
          <h4>Plano escolhido: {plan.info.name}</h4>
          {/* CAMPO DE CUPOM */}
          <div className={"cupom"}>
            <p>
              Tem um cupom? {/* Clique <a onClick={this.toggleCouponField}>aqui</a> para inserir. */}
            </p>
            <div className={classnames(couponClass)}>
              <input type={"text"} value={state.couponName} onChange={this.updateCouponField} />
              <div>
                <button className={"btn btn-sm btn-light-lime px-1"} onClick={this.sendCouponField}>
                  Aplicar
                </button>
                <button className={"btn btn-sm btn-light-pink px-1"} onClick={this.resetCouponField}>
                  Limpar
                </button>
              </div>
            </div>
            {(() => {
              if (plan.coupon.couponInfo !== null) {
                return (
                  <small className={"alert danger my-2"} style={{ color: "#20511a", backgroundColor: "#a5e09f", border: "1px solid #20511a", padding: "1rem" }}>
                    {plan.coupon.couponInfo.freebieMessage}
                  </small>
                );
              } else {
                return null;
              }
            })()}
          </div>

          <div className={"w-space"}>
            <p>
              <strong>Edição de Início:</strong> <span>{state.data.restartEditionTheme}</span>
            </p>
            {(() => {
              if (desconto) {
                return (
                  <p>
                    <strong>Desconto:</strong> <span>{desconto}</span>
                  </p>
                );
              }

              return null;
            })()}
            <p>
              <strong>Frete:</strong> <span>{frete}</span>
            </p>
            <p>
              <strong>Valor Total:</strong> <span>{fullPrice}</span>
            </p>
            <p>
              <strong>Valor Parcelado:</strong> <span>{displayPrice}</span>
            </p>
            <small>Não esqueça de conferir o endereço para envio</small>
          </div>

          {/* CONTEÚDO DE CARTÃO DE CRÉDITO */}
          {/* CARTÃO DE CRÉDITO */}
          {this.renderCreditCard()}

          <div className={"rn-md-termos"}>
            <input
              type={"checkbox"}
              checked={state.termsAccepted}
              onChange={this.toggleTermsAccepted} />
            <label> Eu aceito os <a onClick={this.toggleTermsModal} className={"linkAnchor"}>Termos e Condições de Uso</a>
            </label>
          </div>

          <Modal visible={state.termsModal}
            showCloseButton={true}
            onCloseModal={this.toggleTermsModal}>
            <Termos />
          </Modal>

          <div className={"rn-md-footer"}>
            <button disabled={state.couponIsValid === false}
              className={"btn btn-light-lime"}
              onClick={this.submitReactivateData}>
              Renovar
            </button>
          </div>
        </div>
      );
    }

    return (
      <div>
        {currentView}

        <div id={"captchaSubmit"}></div>
       
      </div>
    );
  }
}

AssinaturaRenovar.propTypes = {
  onCancelRenewal: PropTypes.func,
  subscriberId: PropTypes.number.isRequired
};

const mapStateToProps = (state) => ({
  recaptcha: state.ui.recaptcha,
  recaptchaRequest: state.ui.recaptchaRequest,
  partnerGeneral: state.partnerGeneral.data,
  token: state.token.data,
  person: state.person.data
});

const mapDispatchToProps = (dispatch) => ({
  recaptchaRequest: (status) => {
    dispatch(UiActions.recaptchaRequest(status === true));
  },

  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  publishSuccess: (message) => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishError: (message) => {
    dispatch(UiActions.publishErrorAlert(message));
  }
});

AssinaturaRenovar = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssinaturaRenovar);

export {
  AssinaturaRenovar
}